import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-generic-confirmation-modal',
  templateUrl: './generic-confirmation-modal.component.html',
  styleUrls: [],
})
export class GenericConfirmationModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  @Input()
  confirmationTitle: string | null = 'Confirmation'

  @Input()
  confirmationText: string | null = 'Are you sure you want to proceed?'

  @Input()
  confirmButtonText: string | null = 'Confirm'

  @Input()
  cancelButtonText: string | null = 'Cancel'

  @Input()
  confirmButtonClass = 'btn-primary'

  @Input()
  cancelButtonClass = 'btn-secondary'

  confirm() {
    this.activeModal.close(true)
  }

  cancel() {
    this.activeModal.dismiss(false)
  }
}
